module.exports = __webpack_public_path__ + "img/security-audit-img-3.bf3c3b72.png";